module.exports = __webpack_public_path__ + "static/media/36_tn.e91f0bd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/36_tn.jpg
// module id = 345
// module chunks = 0